import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { Translations, I18nHelper } from "../../Lib/Helper/I18nHelper";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import Swal from 'sweetalert2/dist/sweetalert2.js'

@ModuleName("Resubscribe")
export class Resubscribe implements AxInit {

    private token: string;
    private _I18nHelper = new I18nHelper();
    private loading: AxLoading;

    AxInit(): void {
        this.loading = new AxLoading();

        $('#newsLetterLoginForm').on('submit', (e) => {
            AxessViewer.onSubmit(e, $('#newsLetterLoginForm'), '/NewsletterSubscription/Resubscribe', (resp) => {
                if (resp.ErrorNo == 0) {
                    Swal.fire({
                        title: this._I18nHelper.GetTranslation(Translations.LoginSuccess),
                        text: resp['message'],
                        icon: 'success',
                        confirmButtonText: 'Ok'
                    }).then((result) => {
                        $('#loginModal').modal('hide');
                        this.loadSuccessPartial();
                    });
                } else {
                    Swal.fire({
                        title: this._I18nHelper.GetTranslation(Translations.LoginCredentialsWrong),
                        text: resp['message'],
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }
            }, { silent: true }, "");
        });
    }

    loadSuccessPartial() {

        this.loading.ShowLoadingIndicator($('#subscriptionContentHolder')[0]);

        AxessViewer.loadPartialView('/NewsletterSubscription/GetResubscribeSuccessPartial', {}, partial => {
            $('#subscriptionContentHolder').html(partial);
            this.loading.HideLoadingIndicator($('#subscriptionContentHolder')[0]);
        }, { dataType: 'html' });
    }
}